import { render, staticRenderFns } from "./FolderNewForm.vue?vue&type=template&id=2192c90b&"
import script from "./FolderNewForm.vue?vue&type=script&lang=ts&"
export * from "./FolderNewForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports